import { isSSR } from "."
import config from "../config"
import { FluidObject } from "gatsby-image"

export const getDynamicRedirect = (location: Location) => {
  if (isSSR)
    return {
      isRedirect: false,
      href: "",
    }

  // Redirect for shopify orders/invoices/checkouts page
  if (location?.pathname?.match(/^\/\d+\/orders|invoices|checkouts/)) {
    return {
      isRedirect: true,
      href: `https://${config.GATSBY_SHOPIFY_SHOP_DOMAIN_ALT}${location?.pathname}${location.search}`,
    }
  }

  return {
    isRedirect: false,
    href: "",
  }
}

export const sanitizeFluidObject = (fluid?: any): FluidObject | undefined => {
    if (!fluid) return fluid;

    const replaceDomain = (url: string): string =>
      url.replace(/downloads\.ctfassets\.net/g, 'images.ctfassets.net');

    const optionalReplace = (value: string | null | undefined): string | undefined =>
      value ? replaceDomain(value) : undefined;

    return {
      aspectRatio: fluid.aspectRatio,
      src: replaceDomain(fluid.src),
      srcSet: replaceDomain(fluid.srcSet),
      sizes: replaceDomain(fluid.sizes),
      base64: optionalReplace(fluid.base64),
      tracedSVG: optionalReplace(fluid.tracedSVG),
      srcWebp: optionalReplace(fluid.srcWebp),
      srcSetWebp: optionalReplace(fluid.srcSetWebp),
      media: optionalReplace(fluid.media),
    };
  };